var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#00A3A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6964 22.9938C13.47 22.2781 7.72189 16.53 7.00617 9.3036C6.93689 8.60521 7.50987 8 8.25802 8H11.0194C11.5907 8 12.0977 8.36581 12.2782 8.90775L13.1734 11.5919C13.3325 12.0696 13.2077 12.5961 12.8526 12.9508L11.8409 13.9625L12.2953 14.6445C13.1561 15.9366 13.9547 16.7317 15.3523 17.6896L16.0374 18.1591L17.0496 17.1469C17.4043 16.7918 17.9303 16.6674 18.4081 16.8265L21.0926 17.7219C21.6345 17.9024 22 18.4093 22 18.9805V21.7419C22 22.4901 21.3948 23.0631 20.6964 22.9938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallMe);
export default __webpack_public_path__ + "static/media/CallMe.618ca9a128362a87e778211ade167fb9.svg";
export { ForwardRef as ReactComponent };